var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var InfluencingFactorIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 56,
    glyphHeight: 56
  }), React.createElement("path", {
    d: "M28 19.6522C23.4087 19.6522 19.6522 23.4087 19.6522 28C19.6522 32.5914 23.4087 36.3479 28 36.3479C32.5914 36.3479 36.3479 32.5914 36.3479 28C36.3479 23.4087 32.5914 19.6522 28 19.6522Z"
  }), React.createElement("path", {
    d: "M32.1739 11.9304V5.04342L28 0.869507L23.826 5.04342V11.9304C25.0782 11.513 26.5391 11.3043 28 11.3043C29.4608 11.3043 30.9217 11.513 32.1739 11.9304Z"
  }), React.createElement("path", {
    d: "M23.826 44.0695V50.9564L28 55.1303L32.1739 50.9564V44.0695C30.9217 44.4868 29.4608 44.6955 28 44.6955C26.5391 44.6955 25.0782 44.4868 23.826 44.0695Z"
  }), React.createElement("path", {
    d: "M55.1303 28L50.9564 23.826H44.0695C44.4868 25.0782 44.6955 26.5391 44.6955 28C44.6955 29.4608 44.4868 30.9217 44.0695 32.1739H50.9564L55.1303 28Z"
  }), React.createElement("path", {
    d: "M11.9304 23.826H5.04342L0.869507 28L5.04342 32.1739H11.9304C11.513 30.9217 11.3043 29.4608 11.3043 28C11.3043 26.5391 11.513 25.0782 11.9304 23.826Z"
  }));
};
export var InfluencingFactorIconGlyph = function (props) {
  return React.createElement(InfluencingFactorIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};